import { render, staticRenderFns } from "./aftersales.vue?vue&type=template&id=f787895a&scoped=true&"
import script from "./aftersales.vue?vue&type=script&lang=js&"
export * from "./aftersales.vue?vue&type=script&lang=js&"
import style0 from "./aftersales.vue?vue&type=style&index=0&id=f787895a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f787895a",
  null
  
)

export default component.exports